import { darken, transparentize } from 'polished';
import { AssessoriaThemeConfigs } from '../ConnectedThemeProvider';

const getDarkenColor = (
  initialDarken: number,
  color: string,
  dec: number = 0.05
): string => {
  let darkColor = '#000';

  while (initialDarken > 0 && darkColor.slice(0, 4) === '#000') {
    darkColor = darken(initialDarken, color);
    initialDarken = initialDarken - dec;
  }

  if (initialDarken <= 0 && darkColor.slice(0, 4) === '#000') return color;
  else return darkColor;
};

export default function Theme({
  assessoriaPalette,
  lightColor,
  darkColor,
  secondaryDarkColor,
  linkColor,
  fontColor,
  userDataColor,
  hasBorder,
  footerColor,
  headerColor,
  borderRadius,
  nomeFont,
  footerFontColor,
  radiusCards,
  radiusBotoesContato,
}: AssessoriaThemeConfigs) {
  return {
    title: 'light',
    hasBorder: hasBorder,
    borderRadius,

    colors: {
      primary: assessoriaPalette,
      primaryDark1: darkColor || getDarkenColor(0.35, assessoriaPalette),
      primaryDark2:
        secondaryDarkColor || getDarkenColor(0.45, assessoriaPalette, 0.02),
      primaryLight: lightColor || transparentize(0.95, assessoriaPalette),
      userDataColor: userDataColor || '#7B86A3',
      primaryLessLight: transparentize(0.5, assessoriaPalette),
      secundary: '#7B86A3',
      danger: '#FF5670',
      warning: '#FAB100',
      success: '#24C952',
      white: '#FFF',
      black: '#222',
      gray: '#7B86A3',
      lightGray: '#DFE4EF',
      linkColor: linkColor || '#AAAAFF',
      fontColor: fontColor || '#FFF',
      headerColor: headerColor || '#FFF',
      footerColor: footerColor || '#FFF',
      footerFontColor,

      background: {
        primary: '#EEF5FF',
        secondary: '#FFF',
      },

      text: '#9B9B9B',
    },
    radiusCards,
    radiusBotoesContato,

    primaryFont: nomeFont || 'Kumbh Sans',
  };
}
